<app-feature-details-grid>
  <div class="string-value">
    <app-feature-list-container>
      <h3>{{ '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.GENERAL' | translate }}</h3>
      <!-- ventilation.sensors.actuator.selftest -->
      <ng-container *ngIf="ventilationSensorsActuatorSelftest$ | async as feature">
        <app-feature-list-item
          *ngIf="feature?.properties?.enabled || feature?.properties?.status"
          [isNgContent]="true"
        >
          <div class="w-full flex flex-col align-middle justify-between">
            <h4>
              {{
                '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.SENSOR_ACTUATOR_SELFTEST.TITLE'
                  | translate
              }}
            </h4>
            <div *ngIf="feature?.properties?.enabled" class="flex align-middle justify-between">
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.SENSOR_ACTUATOR_SELFTEST.ACTIVE'
                    | translate
                }}
              </p>
              <p>
                {{
                  feature?.properties?.enabled?.value
                    | booleanSuffix
                      : [
                          customTranslationsService.STATE.on | translate,
                          customTranslationsService.STATE.off | translate
                        ]
                }}
              </p>
            </div>
            <div *ngIf="feature?.properties?.status" class="flex align-middle justify-between">
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.SENSOR_ACTUATOR_SELFTEST.STATUS'
                    | translate
                }}
              </p>
              <p>
                {{
                  (customTranslationsService.VENTILATION_SERVICE_LAYER_STATUS[
                    feature?.properties?.status?.value
                  ] | translate) ?? NO_VALUE
                }}
              </p>
            </div>
          </div>
        </app-feature-list-item>
      </ng-container>

      <!-- ventilation.filter.information -->
      <ng-container *ngIf="ventilationFilterInformation$ | async as feature">
        <app-feature-list-item
          [isNgContent]="true"
          *ngIf="
            feature?.properties?.filterRuntimeResetValue ||
            feature?.properties?.filterOneEan ||
            feature?.properties?.filterTwoEan
          "
        >
          <div class="w-full flex flex-col align-middle justify-between">
            <h4>
              {{
                '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.FILTER_INFORMATION.TITLE'
                  | translate
              }}
            </h4>
            <div
              *ngIf="feature?.properties?.filterRuntimeResetValue"
              class="flex align-middle justify-between"
            >
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.FILTER_INFORMATION.RESET_RUNTIME'
                    | translate
                }}
              </p>
              <p>
                {{ feature | value2: featurePropertyKey.filterRuntimeResetValue }}
                {{ feature.properties.filterRuntimeResetValue.unit
                }}{{ feature.properties.filterRuntimeResetValue.value > 1 ? 's' : '' }}
              </p>
            </div>
            <div
              *ngIf="feature?.properties?.filterOneEan"
              class="flex align-middle justify-between"
            >
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.FILTER_INFORMATION.FILTER_ONE_EAN'
                    | translate
                }}
              </p>
              <p>
                {{ feature | value2: featurePropertyKey.filterOneEan }}
              </p>
            </div>
            <div
              *ngIf="feature?.properties?.filterTwoEan"
              class="flex align-middle justify-between"
            >
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.FILTER_INFORMATION.FILTER_TWO_EAN'
                    | translate
                }}
              </p>
              <p>
                {{ feature | value2: featurePropertyKey.filterTwoEan }}
              </p>
            </div>
          </div>
        </app-feature-list-item>
      </ng-container>

      <!-- ventilation.lockExternal -->
      <ng-container *ngIf="ventilationLockExternal$ | async as feature">
        <app-feature-list-item
          [isNgContent]="true"
          *ngIf="feature?.properties?.airPressureMonitor || feature?.properties?.fireProtectionFlap"
        >
          <div class="w-full flex flex-col align-middle justify-between">
            <h4>
              {{
                '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.LOCK_EXTERNAL.TITLE' | translate
              }}
            </h4>
            <div
              *ngIf="feature?.properties?.airPressureMonitor"
              class="flex align-middle justify-between"
            >
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.LOCK_EXTERNAL.AIR_PRESSURE_MONITOR'
                    | translate
                }}
              </p>
              <p>
                {{
                  feature?.properties?.airPressureMonitor?.value
                    | booleanSuffix
                      : [
                          customTranslationsService.STATE.on | translate,
                          customTranslationsService.STATE.off | translate
                        ]
                }}
              </p>
            </div>
            <div
              *ngIf="feature?.properties?.fireProtectionFlap"
              class="flex align-middle justify-between"
            >
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.LOCK_EXTERNAL.FIRE_PROTECTION_FLAP'
                    | translate
                }}
              </p>
              <p>
                {{
                  feature?.properties?.fireProtectionFlap?.value
                    | booleanSuffix
                      : [
                          customTranslationsService.STATE.on | translate,
                          customTranslationsService.STATE.off | translate
                        ]
                }}
              </p>
            </div>
          </div>
        </app-feature-list-item>
      </ng-container>
      <!-- ventilation.fan.assignmentSwitch -->
      <ng-container *ngIf="ventilationFanAssignmentSwitch$ | async as feature">
        <app-feature-list-item [isNgContent]="true" *ngIf="feature?.properties?.active">
          <div
            *ngIf="feature?.properties?.active"
            class="w-full flex flex-col align-middle justify-between"
          >
            <div class="flex align-middle justify-between">
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.FAN_ASSIGNMENT_SWITCH'
                    | translate
                }}
              </p>
              <p>
                {{
                  feature?.properties?.active?.value
                    | booleanSuffix
                      : [
                          customTranslationsService.STATE.on | translate,
                          customTranslationsService.STATE.off | translate
                        ]
                }}
              </p>
            </div>
          </div>
        </app-feature-list-item>
      </ng-container>

      <!-- ventilation.switchActivation -->
      <ng-container *ngIf="ventilationSwitchActivation$ | async as feature">
        <app-feature-list-item *ngIf="feature?.properties?.active" [isNgContent]="true">
          <div
            *ngIf="feature?.properties?.active"
            class="w-full flex flex-col align-middle justify-between"
          >
            <div class="flex align-middle justify-between">
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.PANEL.SERVICE_LAYER.LEVEL_SWITCH_ACTIVATION'
                    | translate
                }}
              </p>
              <p>
                {{
                  feature?.properties?.active?.value
                    | booleanSuffix
                      : [
                          customTranslationsService.STATE.on | translate,
                          customTranslationsService.STATE.off | translate
                        ]
                }}
              </p>
            </div>
          </div>
        </app-feature-list-item>
      </ng-container>
    </app-feature-list-container>
  </div>
</app-feature-details-grid>
